import { MenuItem } from "react-pro-sidebar";
import { NavLink } from "react-router-dom";
import { SideMenu } from "../sideMenu/sideMenu";
import { SideMenuTitle } from "../sideMenu/sideMenuTitle";
import { SideMenuItem } from "../sideMenu/sideMenuItem";
import { Fragment, useRef } from "react";
import { useTranslation } from "react-i18next";
import { constants } from "../../../common/constants/constants";
import { useDispatch, useSelector } from "react-redux";
import CacheData from "../../../common/utils/cacheData";
import { toggleMobileMenuOpened } from "../../../store/common/slice";
import income from "../../../images/newDesign/income.svg";

/**
 * @return {JSX.Element|null}
 * @constructor
 */
export default function IncomeActionsSidebarMenu() {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const menuRef = useRef();
    const localBuildingId = useSelector(state => state.buildings.buildingID ?? CacheData.fetchCache('currentBuilding'));

    const onItemClick = () => {
        dispatch(toggleMobileMenuOpened());
    }

    return (
        <Fragment>
            <MenuItem icon={null} ref={menuRef}>
                <NavLink className="dropdown-link" to={{ pathname: '' }}>
                    {t('buildings.nav_bar_actions')}
                </NavLink>
            </MenuItem>
            <SideMenu container={menuRef.current}>
                <SideMenuTitle
                    label={t('buildings.nav_bar_actions')}
                    icon={income}/>
                <SideMenuItem
                    url={`/${constants.pages.tenantDetailsManagerUrl}/${localBuildingId}`}
                    label={t('buildings.nav_bar_reports_update_payment')}
                    onClick={onItemClick}/>
                <SideMenuItem
                    url={`/${constants.pages.managerTenantRecord}/${localBuildingId}`}
                    label={t('buildings.tenantRecordList')}
                    onClick={onItemClick}/>
            </SideMenu>
        </Fragment>
    );
}
